// An enumerable filter: checkboxes that commit at once, with no Apply. While a refinable filter's refined
// option is selected, one refinement checkbox follows the options; it narrows the match without changing the
// selected count.

import React from 'react'
import PropTypes from 'prop-types'

import { Button } from '@CommonComponents/buttons'
import { useTable } from '../context'
import {
  enumOptions,
  enumSelection,
  enumValue,
  isFilterActive,
  refinementOn,
} from '../query'
import { commitFilter } from './drafts'
import { FilterMenu } from './FilterMenu'

export const EnumEditor = ({ column }) => {
  const { state, dispatch, derived } = useTable()
  const committed = state.query.filters[column.key]
  const selected = enumSelection(committed)
  const refined = refinementOn(committed)
  const { refinement } = column
  const set = (options, refine) =>
    commitFilter(
      dispatch,
      committed,
      column.key,
      enumValue(column, options, refine)
    )
  const toggle = option =>
    set(
      selected.includes(option)
        ? selected.filter(value => value !== option)
        : selected.concat([option]),
      refined
    )
  const showRefinement = Boolean(
    refinement && selected.includes(refinement.option)
  )
  return (
    <>
      <div className="me-table-filter-options">
        {enumOptions(column, derived.data).map(option => (
          <label key={option} className="me-panel-row">
            <input
              type="checkbox"
              checked={selected.includes(option)}
              onChange={() => toggle(option)}
            />
            {option}
          </label>
        ))}
      </div>
      {showRefinement && (
        <div className="me-table-filter-refinement">
          <label className="me-panel-row">
            <input
              type="checkbox"
              checked={refined}
              onChange={() => set(selected, !refined)}
            />
            {refinement.label}
          </label>
        </div>
      )}
      <div className="me-panel-foot">
        <Button
          className="me-btn me-btn-ghost me-btn-xs"
          aria-disabled={!isFilterActive(committed) || undefined}
          onClick={() => set([], false)}
        >
          Clear filter
        </Button>
      </div>
    </>
  )
}

EnumEditor.propTypes = {
  column: PropTypes.object.isRequired,
}

export const EnumFilter = ({ column }) => (
  <FilterMenu column={column}>
    <EnumEditor column={column} />
  </FilterMenu>
)

EnumFilter.propTypes = {
  column: PropTypes.object.isRequired,
}
